angular.module('charts')
    .directive('dblInfoPopup', [function() {

        return {
            restrict: 'E',
            scope: {
                dblMessage: '=',
                dblContainer: '@',
                dblMaxWidth: '@'
            },
            templateUrl: '/resources/charts/directives/info-popup/dbl-info-popup.directive.html',
            controller: ['$element', '$scope', function ($element, $scope) {
                var popoverOptions = {
                    container: $scope.dblContainer || 'body',
                    html: true,
                    placement: 'auto bottom',
                    trigger: 'hover'
                };

                $scope.$watch('dblMessage', function (value) {
                    if (value) {
                        popoverOptions.content = value;
                        $element.popover(popoverOptions)
                          .on("show.bs.popover", function () {
                              if ($scope.dblMaxWidth) {
                                $(this).data("bs.popover").tip().css("max-width", $scope.dblMaxWidth);
                              }
                          });
                    }
                });
            }]
        };
    }]);
